var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.getters.isEnterprise)?_c('enterprise-home'):_vm._e(),(_vm.$store.getters.isEcosystem)?_c('ecosystem-home'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }